import { useQuery } from "@tanstack/react-query";
import { OrganisationService } from "../services/organisationService.ts";

export const useOrganisation = (organisationId: string) => {
  return useQuery({
    queryKey: ["organisation", organisationId],
    queryFn: async () => {
      return GetOrganisationDetailsFn(organisationId) ;
    },
  });
};

export const GetOrganisationDetailsFn = async (organisationId: string) => {
  return await OrganisationService.getOrganisationDetails(organisationId)
}